import { useState } from "react";

/**
 * Кастомний хук для каруселі / слайдів
 * @param slidesCount — кількість слайдів
 * @param initialIndex — початковий активний індекс
 */
export function useCarousel(slidesCount: number, initialIndex = 0) {
    const [activeIndex, setActiveIndex] = useState(initialIndex);

    const goTo = (index: number) => {
        if (index < 0) return setActiveIndex(0);
        if (index >= slidesCount) return setActiveIndex(slidesCount - 1);
        setActiveIndex(index);
    };

    return { activeIndex, setActiveIndex: goTo };
}
